// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1nRp4","row":"ProcedureTreatmentSummary_row__yFRR2"};